import api from 'store/api';
import {
  SubscriptionData,
  SubscriptionFilters,
  SubscriptionInvoiceData,
  SubscriptionInvoiceFilters,
  SubscriptionMutationRequest,
  SubscriptionPostResponse,
} from './interfaces';

export const subscriptionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptions: builder.query<
      SubscriptionData,
      Partial<SubscriptionFilters>
    >({
      query: (filters) => ({ url: '/subscriptions', params: filters }),
      providesTags: ['Subscriptions'],
    }),
    submitSubscription: builder.mutation<
      SubscriptionPostResponse,
      SubscriptionMutationRequest
    >({
      query: (body) => ({ url: '/subscriptions', method: 'POST', body }),
      invalidatesTags: ['Subscriptions'],
    }),
    getSubscriptionInvoices: builder.query<
      SubscriptionInvoiceData,
      SubscriptionInvoiceFilters
    >({
      query: ({ id, ...filters }) => ({
        url: `/subscriptions/${id}/invoices`,
        params: filters,
      }),
      providesTags: ['Subscriptions'],
    }),
  }),
});

export const {
  useGetSubscriptionsQuery,
  useSubmitSubscriptionMutation,
  useGetSubscriptionInvoicesQuery,
} = subscriptionApi;
